import React from 'react';
import { Shield, Award, Cog, Handshake } from 'lucide-react';
import { siteConfig } from '../config/siteConfig';

const iconMap = {
  0: Shield,
  1: Award,
  2: Cog,
  3: Handshake
};

export const AboutSection = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-header">
          <h2 className="section-title">Про компанію</h2>
          <div className="section-divider"></div>
          <p className="about-text">
            {siteConfig.aboutText}
          </p>
        </div>

        <div className="features-grid">
          {siteConfig.features.map((feature, index) => {
            const Icon = iconMap[index];
            return (
              <div key={index} className="feature-card">
                <div className="feature-icon-wrapper">
                  <Icon className="feature-icon" size={32} />
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
